import type { IconSvgObject } from './types';

const SquareArrowShrink01Icon: IconSvgObject = [
  ["path", { d: "M21.5 4.50006V19.5001C21.5 20.6046 20.6046 21.5001 19.5 21.5001H4.5C3.39543 21.5001 2.5 20.6046 2.5 19.5001V4.50006C2.5 3.39549 3.39543 2.50006 4.5 2.50006H19.5C20.6046 2.50006 21.5 3.39549 21.5 4.50006Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 10.5001L7 7.00006M8 11.0001L11 11.0001L11 8.00006", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 17.0001L13.5 13.5001M16 13.0001L13 13.0001L13 16.0001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SquareArrowShrink01Icon;
